export default {"src":"/_next/static/media/tailwind.c0bbaf6f.svg","height":154,"width":256,"blurWidth":0,"blurHeight":0};